export function exportToCsv(filename, rows) {
  if (!rows || rows.length === 0) {
    return;
  }

  const separator = ";"; // Excel FR préfère le point-virgule
  const headers = Object.keys(rows[0]);

  const csvContent = [
    headers.join(separator),
    ...rows.map((row) =>
      headers
        .map((header) => {
          let cell =
            row[header] === null || row[header] === undefined
              ? ""
              : row[header];
          cell = String(cell).replace(/"/g, '""');
          if (cell.includes(separator) || cell.includes("\n")) {
            cell = `"${cell}"`;
          }
          return cell;
        })
        .join(separator),
    ),
  ].join("\n");

  // BOM pour un affichage correct des accents dans Excel
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
